var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"success","icon":"el-icon-document-add","size":_vm.size},on:{"click":_vm.createSite}},[_vm._v(" "+_vm._s(_vm.$t('tabs.start.createProject'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }